import { Component } from '@angular/core';

@Component({
    templateUrl: './attributes.component.html',
    styleUrls: ['./attributes.component.scss']
})
export class AttributesComponent {

}
